// A meeting is full of people the app has never seen - guests with no account,
// no avatar and no profile. Falling back to the Cyclone logo for all of them
// (which is what VideoGridOverlay does for group rooms, where everyone is a
// known member) would make every camera-off tile identical. Instead each
// participant gets a stable colour and their initials, so a silent, camera-off
// grid is still readable at a glance.

// Deliberately not the theme's accent colours: these have to stay distinct
// from each other first and foremost, and they sit behind white text, so they
// are all chosen dark enough to keep that readable.
const TILE_COLORS = [
    ['#1f6f63', '#0f3d37'],
    ['#2b4b8f', '#16274d'],
    ['#8f2b55', '#4d162d'],
    ['#7a4a1f', '#42260f'],
    ['#4b2b8f', '#28164d'],
    ['#1f5f8f', '#0f334d'],
    ['#6f1f4b', '#3d0f29'],
    ['#2f6f2b', '#183d16'],
    ['#8f6b1f', '#4d390f'],
    ['#3d3d6b', '#1f1f3d']
];

// FNV-1a. Any stable hash would do; the requirement is only that the same
// identity picks the same colour on every participant's screen and across
// reloads, so that "the teal tile" means one person for everyone in the call.
function hashIdentity(identity) {
    let hash = 0x811c9dc5;
    for (let i = 0; i < identity.length; i++) {
        hash ^= identity.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return hash;
}

export function tileGradient(identity) {
    const [from, to] = TILE_COLORS[hashIdentity(identity || '') % TILE_COLORS.length];
    return `radial-gradient(circle at 50% 45%, ${from} 0%, ${to} 100%)`;
}

export function avatarColor(identity) {
    return TILE_COLORS[hashIdentity(identity || '') % TILE_COLORS.length][0];
}

// First letter of the first two words - "Adem Çınarcı" -> "AÇ", "Ahmet" -> "A".
// Uses the spread operator rather than charAt so a name starting with an
// astral-plane character (an emoji nickname, which guests do use) yields that
// whole character instead of half a surrogate pair.
export function initialsOf(name) {
    const words = (name || '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    return words.slice(0, 2).map((word) => [...word][0].toLocaleUpperCase('tr')).join('');
}
